module.exports = __webpack_public_path__ + "img/c680a5c.png";